let authSessionId = 0;

export const getAuthSessionId = () => authSessionId;

export const bumpAuthSession = () => {
  authSessionId += 1;
  return authSessionId;
};

export class StaleAuthSessionError extends Error {
  constructor() {
    super("Stale auth session");
    this.name = "StaleAuthSessionError";
  }
}

export const assertAuthSession = (sessionAtStart) => {
  if (sessionAtStart !== authSessionId) {
    throw new StaleAuthSessionError();
  }
};
